import React, { useState } from "react";
import { resetDevice } from "../../functions/user/resetDevice";
import { useNavigate } from "react-router";

const ResetDeviceModal = ({ setResetModal, userId }) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(
    "Are you sure you want to reset this user's device?"
  );
  const [showConfirmBtn, setShowConfirmBtn] = useState(true);

  const handleClose = () => {
    setResetModal(false);
    navigate(`/viewUserInfo`);
  };

  const confirmed = async () => {
    const result = await resetDevice(userId);

    if (result.result !== 0) {
      setMessage("Error: Failed to reset user's device.");
      setShowConfirmBtn(false);
    } else {
      setMessage(`Success: Device reset.`);
      setShowConfirmBtn(false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={() => handleClose()} />
      <div className="modal-wrapper">
        <div className="modal">
          <div className="modal-header">
            <h5 className="modal-heading">Confirmation</h5>
          </div>
          <div className="modal-message">{message}</div>
          <div className="modal-btns">
            {showConfirmBtn && (
              <button className="modal-confirm-btn" onClick={() => confirmed()}>
                Confirm
              </button>
            )}
            <button className="modal-cancel-btn" onClick={() => handleClose()}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetDeviceModal;
